// src/data/defaultAvatars.js
export const defaultAvatars = [
  {
    id: 1,
    url: "https://i.pinimg.com/1200x/4e/e3/c3/4ee3c39948a03660c3412516cec37e0b.jpg",
  },
  { id: 2, url: "https://i.pinimg.com/736x/8b/6b/52/8b6b52509b318454e3d4af4dc5b008f3.jpg" },
  { id: 3, url: "https://i.pinimg.com/736x/36/0b/45/360b45b94af38e1f6ab544f7b45321aa.jpg" },
  { id: 4, url: "https://i.pinimg.com/736x/3c/61/23/3c6123aa04908249698efc04b6af04aa.jpg" },
  { id: 5, url: "https://i.pinimg.com/736x/2c/3e/4a/2c3e4a96f3196b45ce3c1508fce65cc9.jpg" },
  { id: 6, url: "https://i.pinimg.com/736x/0e/73/9b/0e739bb713a42a3d2b917b4e58971dbf.jpg" },
  { id: 7, url: "https://i.pinimg.com/736x/a0/7f/86/a07f86efe7583afd5c9775e635acecb1.jpg" },
  { id: 8, url: "https://i.pinimg.com/736x/a9/9a/ec/a99aeca11a7d509ce41a27da5d95ff09.jpg" },
];
